function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalculate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 200",
    style: {
      enableBackground: "new 0 0 200 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3B086B"
    },
    d: "M50.4,198c-16.1,0-29.2-13.1-29.2-29.2V31.2C21.2,15.1,34.3,2,50.4,2h99.2 c16.1,0,29.2,13.1,29.2,29.2v98.4c-0.2,4-3,5.8-5.8,5.8s-5.7-1.8-5.8-5.9v-64c0-1.1-0.9-2-2-2H34.8c-1.1,0-2,0.9-2,2v103.1 c0,9.7,7.9,17.6,17.6,17.6h99.2c9.7,0,17.6-7.9,17.6-17.6c0-3.2,2.6-5.8,5.8-5.8s5.8,2.6,5.8,5.8c0,16.1-13.1,29.2-29.2,29.2H50.4 V198z M50.4,13.6c-9.7,0-17.6,7.9-17.6,17.6V50c0,1.1,0.9,2,2,2h130.4c1.1,0,2-0.9,2-2V31.2c0-9.7-7.9-17.6-17.6-17.6H50.4z  M133.2,162.1c-4-0.2-5.8-3-5.8-5.8s1.8-5.7,5.9-5.8h8.5c4,0.2,5.8,3,5.8,5.8s-1.8,5.6-5.8,5.8H133.2z M58.6,162.1 c-4-0.2-5.8-3-5.8-5.8s1.8-5.7,5.9-5.8h44.8c4,0.2,5.8,3,5.8,5.8s-1.8,5.6-5.8,5.8H58.6z M133.2,132.4c-4-0.2-5.8-3-5.8-5.8 s1.8-5.7,5.9-5.8h8.5c3.2,0,5.8,2.6,5.8,5.8c0,3.2-2.6,5.8-5.8,5.8H133.2z M95.7,132.4c-4-0.2-5.8-3-5.8-5.8s1.8-5.7,5.9-5.8h8.5 c4,0.2,5.8,3,5.8,5.8s-1.8,5.6-5.8,5.8H95.7z M58.2,132.4c-4-0.2-5.8-3-5.8-5.8s1.8-5.7,5.9-5.8h8.5c4,0.2,5.8,3,5.8,5.8 s-1.8,5.6-5.8,5.8H58.2z M133.2,102.7c-4-0.2-5.8-3-5.8-5.8s1.8-5.7,5.9-5.8h8.5c4,0.2,5.8,3,5.8,5.8s-1.8,5.6-5.8,5.8H133.2z  M95.7,102.7c-4-0.2-5.8-3-5.8-5.8s1.8-5.7,5.9-5.8h8.5c4,0.2,5.8,3,5.8,5.8s-1.8,5.6-5.8,5.8H95.7z M58.2,102.7 c-4-0.2-5.8-3-5.8-5.8s1.8-5.7,5.9-5.8h8.5c4,0.2,5.8,3,5.8,5.8s-1.8,5.6-5.8,5.8H58.2z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculate);
export default __webpack_public_path__ + "static/media/calculate.6377b500996d01b261c09ded07431616.svg";
export { ForwardRef as ReactComponent };